export default "__VITE_ASSET__DF0EIH3C__"